import { useEffect, useState } from 'react';
import { Draggable } from 'react-beautiful-dnd';
import { Card } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import TaskCard from '../TaskCard';

export default function DynamicBoardTask({ index, task }) {
  const [archived, setArchived] = useState(task?.archived ?? 0);
  
  useEffect(() => {
    setArchived(task.archived);
  }, [task?.archived]);

  if (Boolean(Number(archived))) return <></>;

  return (
    <Draggable 
      draggableId={`draggable-task-${task.id}`} 
      index={index}
      isDragDisabled={false}
    >
      {(provided, snapshot) => (
        <Link 
          className="mb-2 d-block text-decoration-none text-dark"
          ref={provided.innerRef}
          role="button" 
          to={`/projects/task/${task.id}`} 
          {...provided.draggableProps}
          {...provided.dragHandleProps}
        >
          <Card className={`taskCard mb-2 p-2 border-0 ${snapshot.isDragging ? 'shadow dragging' : 'shadow-sm'}`}>

            <TaskCard task={task} />
            
          </Card>
        </Link>
      )}
    </Draggable>
  )
}